'use client';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTranslations } from 'next-intl';

import Hamburger from '@/components/Header/Hamburger';
import LanguagePicker from '@/components/LanguagePicker';
import { Link } from '@/i18n/navigation';

import styles from './Actions.module.scss';

interface ActionsProps {
  menuOpen?: boolean;
  onMenuToggle?: () => void;
}

const Actions = ({ menuOpen = false, onMenuToggle }: ActionsProps) => {
  const t = useTranslations('common');

  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <LanguagePicker />
      <Box className={styles.hamburgerWrapper}>
        <Hamburger open={menuOpen} onToggle={onMenuToggle!} />
      </Box>
      <Box className={styles.ctaButtonWrapper}>
        <Button component={Link} href="/contact">
          {t('getInTouch')}
        </Button>
      </Box>
    </Stack>
  );
};

export default Actions;
